import * as React from "react"
import type { SVGProps } from "react"
const SvgWallet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M17.08 15.5q-.43.43-1.08.43a1.46 1.46 0 0 1-1.5-1.5 1.46 1.46 0 0 1 1.5-1.5 1.45 1.45 0 0 1 1.5 1.5q0 .65-.42 1.07" />
    <path
      fillRule="evenodd"
      d="M3 7.43Q3 5.78 4.18 4.6A4 4 0 0 1 7 3.43h11a1 1 0 1 1 0 2H7q-.82 0-1.41.59A2 2 0 0 0 5 7.42h14q.83 0 1.41.6.6.59.59 1.4v10q0 .84-.59 1.42a2 2 0 0 1-1.41.59H5q-.82 0-1.41-.59A2 2 0 0 1 3 19.43zm2 2v10h14v-10z"
    />
  </svg>
)
export default SvgWallet
